import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const MissionRequestTypeEnum = Object.freeze({
  1: i18n.t('RequestType.NewRequest'),
  3: i18n.t('RequestType.RefuseRequest'),
  4: i18n.t('RequestType.ReturnRequest'),
  2: i18n.t('RequestType.ConfirmRequest'),
  5: i18n.t('RequestType.AllMissionRequest'),
  7: i18n.t('RequestType.SuspendRequest'),
})

const MissionRequestTypeArray = function () {
  return ArrayUtils.EnumToArray(MissionRequestTypeEnum)
}
export default { MissionRequestTypeEnum, MissionRequestTypeArray };